/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SubAssetType = {
    ETF: 'ETF',
    ETN: 'ETN',
    ETV: 'ETV',
    BOND: 'Bond',
    BILL: 'Bill',
    NOTE: 'Note'
} as const;
export type SubAssetType = typeof SubAssetType[keyof typeof SubAssetType];


export function instanceOfSubAssetType(value: any): boolean {
    for (const key in SubAssetType) {
        if (Object.prototype.hasOwnProperty.call(SubAssetType, key)) {
            if (SubAssetType[key as keyof typeof SubAssetType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubAssetTypeFromJSON(json: any): SubAssetType {
    return SubAssetTypeFromJSONTyped(json, false);
}

export function SubAssetTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubAssetType {
    return json as SubAssetType;
}

export function SubAssetTypeToJSON(value?: SubAssetType | null): any {
    return value as any;
}

export function SubAssetTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SubAssetType {
    return value as SubAssetType;
}

